import Footer from './Footer';

// export types
export type { FooterProps } from './Footer';

// export components
export { Footer };
export default Footer;
